import React from "react";
import {
  Card,
  CardActionArea,
  Grid,
  Container,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomAppBar from "../../components/AppBar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "../../components/Icon";
const useStyles = makeStyles(() => ({
  carStyle: {
    border: "1px solid #A5A5A5 !important",
  },
  cardTitle: {
    fontSize: "25px !important",
    fontStyle: "Poppins  !important",
    lineHeight: "37.5px  !important",
    marginTop: "20px !important",
  },
}));
export default function LenderLandingPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const buttons = [
    {
      label: t("My Borrowers"),
      type: "my-borrowers",
      route: "/lender/my-borrowers",
    },
    {
      label: t("Prospects"),
      type: "prospects",
      route: "/lender/prospect-borrowers",
    },
    {
      label: t("Request Received"),
      type: "received-loan",
      route: "/lender/requests",
    },
    {
      label: t("My Loan"),
      type: "my-loan",
      route: "/lender/my-loans",
    },
  ];

  return (
    <div>
      <CustomAppBar />
      <Container maxWidth="xs" style={{ marginTop: 20 }}>
        <Grid container spacing={2}>
          {buttons.map((button, index) => (
            <Grid
              item
              xs={12}
              key={index}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                variant="outlined"
                style={{ width: "100%", height: 162 }}
                className={classes.carStyle}
              >
                <CardActionArea
                  onClick={() => navigate(button.route)}
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon type={button.type} />
                  <div>
                    <Typography className={classes.cardTitle}>
                      {button.label}
                    </Typography>
                  </div>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
